import { render, staticRenderFns } from "./HeaderUi.vue?vue&type=template&id=ae44abde&scoped=true&"
var script = {}
import style0 from "./HeaderUi.vue?vue&type=style&index=0&id=ae44abde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae44abde",
  null
  
)

export default component.exports